module.exports = "/fonts/h2h-logotype-l-a9699487098129ee3a48ce634938e158.svg";